import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PrivacyState {
  /** ocultar valores monetários (olho fechado). */
  hidden: boolean;
  toggle: () => void;
}

export const usePrivacyStore = create<PrivacyState>()(
  persist(
    (set) => ({
      hidden: false,
      toggle: () => set((s) => ({ hidden: !s.hidden })),
    }),
    { name: 'lira-privacy' },
  ),
);
